import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../../../api/apiRoutes";
import { appFetchJson } from "../../../../../utils/http";
import InputNumberNoScroll from "../../../../../components/inputs/inputNumberNoScroll";

export default function CrearIva({ onClose = () => {}, onCreated = () => {} }) {
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [pr, setPr] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = codigo.trim() !== "" && nombre.trim() !== "" && pr !== "";

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const guardar = async () => {
    if (!isValid || saving) return;
    setSaving(true);
    setError("");
    try {
      const payload = {
        codigo: codigo.trim(),
        nombre: nombre.trim(),
        pr: Number(pr),
      };
      const created = await appFetchJson(apiRoutes.ivas.create, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
      });
      onCreated(created);
      onClose();
    } catch (e) {
      console.error("Error creando IVA:", e);
      setError(e?.message || "Ocurrió un error al guardar el IVA.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear IVA</h2>
          <button className="modal-close-x" onClick={onClose}><FaTimes /></button>
        </div>
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">Introduzca los datos del nuevo IVA</p>
          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}
          <div className="space-y-4">
            <div><label className="form-label">Código *</label><input type="text" className="input" value={codigo} onChange={e => setCodigo(e.target.value)} placeholder="Código del IVA" /></div>
            <div><label className="form-label">Descripción *</label><input type="text" className="input" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Nombre del IVA" /></div>
            <div>
              <label className="form-label">Porcentaje *</label>
              <InputNumberNoScroll
                step="1"
                className="input"
                value={pr}
                onChange={e => setPr(e.target.value === "" ? "" : Number(e.target.value))}
                placeholder="Porcentaje de IVA"
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar label="Guardar" isValid={isValid} saving={saving} onClick={guardar} />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}